(ns teamoesterreich.admin-mode.toe-list.toe-sort-table
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.view-state :as v-state]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [reagent.core :as r]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.admin-mode.data.organisation :as d-organisation]
            [reagent-material-ui.icons.edit :as ic-edit]
            [reagent-material-ui.icons.warning :as ic-warning]
            [teamoesterreich.admin-mode.static-data :as staticData]))


(defonce DEGREES (reduce (fn [c [k n]] (assoc c k n)) {} staticData/DEGREES))
(defonce EXPERTS (reduce (fn [c [k n]] (assoc c k n)) {} staticData/EXPERT))
(defonce JOB-STATUS (reduce (fn [c [k n]] (assoc c k n)) {} staticData/JOB-STATUS))





(defn filter-fn [rows search]
  ;;(println "filter-fn " (count rows) search)
  (filter (fn [e]
            (re-find
              (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split search " ")))
              (str (:user-tomId e) "#" (:user-firstName e) "#" (:user-lastName e) "#" (:user-email e) "#" (:user-phoneNumber e))))
          rows))

(defn select-me-renderer [!st]
  (fn [js-parm]
    (let [{cell-data "cellData"} (js->clj js-parm)]
      (r/as-element
        [mui/checkbox
         {:onChange (fn [_ val] (swap! !st assoc-in [:selected cell-data] val))
          :checked  (or (get-in @!st [:selected cell-data]) false)
          }
         ]))))

(defn email-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    ;(println "email-cell-renderer " cell-data)
    (r/as-element
      [:a {:href (str "mailto:" cell-data) :title cell-data} cell-data])))

(defn birthday-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        ;l-date (date-h/parse-local-date cell-data)
        ]
    ;(js/console.log l-date)
    (r/as-element
      [:span (if (> (count cell-data) 10)
               (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4))
               "-")])))

(defn org-renderer [dst-list]
  (fn [js-parm]
    (let [{rowData "rowData"} (js->clj js-parm)
          cell-data (get rowData "orgId")]
      ;(js/console.log "rowData" (clj->js (get rowData "orgId")))
      (r/as-element
        [:span (or (get dst-list cell-data) (str "" cell-data))]))))

(defn degree-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [:span (or (get DEGREES cell-data) (str "" cell-data))])))


(defn expert-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [:span (or (get EXPERTS cell-data) (str "" cell-data))])))

(defn job-status-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [:span (or (get JOB-STATUS cell-data) (str "" cell-data))])))

(defn get-language-string [u]
  (try
    (reduce (fn [c le]
              (let [[l q] (clojure.string/split le #"\#")]
                (if (= q "del")
                  c
                  (str c l " " (or (get staticData/LANGUAGE_LEVELS_ABBR q) q) ", "))))
            ""
            (clojure.string/split (:user-language u) #"\|"))
    (catch :default e "")))

(defn lang-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        cell-data (get-language-string cell-data)]
    (r/as-element
      [:span cell-data])))

(defn check-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [mui/checkbox {:disabled true :checked (true? cell-data)}])))
(defn profile-valid-renderer [js-parm]
  (let [{profile-valid "cellData"
         row-data      "rowData"} (js->clj js-parm)
        hint (get row-data "profileValidHint")]
    (r/as-element
      (if profile-valid
        [mui/checkbox {:disabled true :checked true}]
        [:div {:style {:verticalAlign "top"}}
         [ic-warning/warning {:style {:color "orange"}}]
         [:div {:style {:fontSize "smaller"} :title (str "" hint)} hint]
         ]))))


(defn edit-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [mui/icon-button {:label   "bearbeiten"
                        :onClick #(swap! v-state/app-state assoc-in [:toe-map :activeUserPopup] cell-data)
                        } [ic-edit/edit {:fontSize "small"}]]
      )))


(defn tom-link-renderer [js-parm]
  (let [{tomId "cellData"} (js->clj js-parm)]
    (r/as-element
      (if (d-rights/allow-admin-for d-rights/USER)
        [:a {:href (str "/#user-view$" tomId) :target "_blank"} (str tomId )]
        tomId)
      )))


(defn inside-table [!st rows]

  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          !loaded (r/cursor !st [:loaded])
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])
          !searchAddFields (r/cursor !st [:searchAddFields])
          !filter (r/cursor !st [:filter])


          _ (d-organisation/get-store-organisations)
          !organisations (r/cursor v-state/app-state [:organisations])
          dst-list (reduce (fn [c [k v]] (assoc c k v)) {} (d-organisation/get-dest-list @!organisations))

          memberMode (get-in @!filter [:add-filter-member-show])
          wanadoMode (get-in @!filter [:add-filter-wanado-show])
          tafelMode (get-in @!filter [:add-filter-tafel-show])
          lrMode (or (:filter-lebensretter @!filter)
                     (:filter-lebensretterActive @!filter)
                     (:filter-firstResponderActive @!filter)
                     (:filter-lr-clearance-from @!filter)
                     (:filter-lr-clearance-to @!filter)
                     (:filter-lrSince-from @!filter)
                     (:filter-lrSince-to @!filter)
                     (:filter-lrSource @!filter))
          ]
      (log/debug "TOE Sort Table ---  inside-table: FILTER:" (clj->js @!filter) "  SRCH_ADD:" (clj->js @!searchAddFields))
      (r/as-element
        [:> rv/Table
         {:headerHeight    50
          :height          (- height 50)
          :rowCount        (count rows)
          :rowGetter       (fn [i]
                             ;(println (str "rowGet " (aget i "index")))
                             (clj->js (nth rows (aget i "index"))))
          :rowClassName    (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort            (fn [s]
                             (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection")))
                             (reset! !loaded false)
                             )
          :sortBy          @!sort
          :sortDirection   (if @!reverse "DESC" "ASC")
          :rowHeight       45
          :width           width
          :headerClassName "headerColumn"
          :className       "ToeList"}



         [:> rv/Column
          {:label        (r/as-element [mui/checkbox {:clickable "false"}])
           :dataKey      (name :tomId)
           :className    "bordered exampleColumn"
           :cellRenderer (select-me-renderer !st)
           :width        70} [:a {:href ""}]]

         (when (d-rights/allow-admin-for d-rights/USER)
           [:> rv/Column
            {:label        (r/as-element [ic-edit/edit])
             :dataKey      "tomId"
             :className    "bordered exampleColumn"
             :cellRenderer edit-cell-renderer
             :width        70}])

         [:> rv/Column
          {:label     "TomId"
           :dataKey   (name :tomId)
           :className "bordered exampleColumn"
           :cellRenderer tom-link-renderer
           :style     #js {:overflow "hidden"}
           :width     70}]
         [:> rv/Column
          {:label     "Vorname"
           :dataKey   (name :firstName)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden"}
           :width     170}]
         [:> rv/Column
          {:label     "Nachname"
           :dataKey   (name :lastName)
           :className "bordered exampleColumn"
           :width     170}]


         (when (get-in @!searchAddFields [:email])
           [:> rv/Column
            {:label     "Email"
             :dataKey   (name :email)
             :className "bordered exampleColumn"
             :width     170}])

         (when (get-in @!searchAddFields [:phone])
           [:> rv/Column
            {:label     "Handy"
             :dataKey   (name :phoneNumber)
             :className "bordered exampleColumn"
             :width     170}])

         (when (get-in @!searchAddFields [:city])
           [:> rv/Column
            {:label     "Ort"
             :dataKey   (name :city)
             :className "bordered exampleColumn"
             :width     170}])

         (when (get-in @!searchAddFields [:zip])
           [:> rv/Column
            {:label     "Plz"
             :dataKey   (name :zip)
             :className "bordered exampleColumn"
             :width     170}])

         (when (get-in @!searchAddFields [:address])
           [:> rv/Column
            {:label     "Adresse"
             :dataKey   (name :address)
             :className "bordered exampleColumn"
             :width     170}])

         (when (get-in @!searchAddFields [:dienststelle])
           [:> rv/Column
            {:label        (txt/txt :rights-level 2)
             :dataKey      (name :lv)
             :className    "bordered exampleColumn"
             :width        120}])


         (when (get-in @!searchAddFields [:dienststelle])
           [:> rv/Column
            {:label        (txt/txt :rights-level 3)
             :cellRenderer (org-renderer dst-list)
             :dataKey      (name :orgId)
             :className    "bordered exampleColumn"
             :width        170}])

         (when (get-in @!searchAddFields [:birthday])
           [:> rv/Column
            {:label        "Geburtsdatum"
             :dataKey      (name :birthday)
             :cellRenderer degree-renderer
             :className    "bordered exampleColumn"
             :width        170}])

         (when (get-in @!searchAddFields [:studium])
           [:> rv/Column
            {:label        "Studium"
             :dataKey      (name :studium)
             :cellRenderer degree-renderer
             :className    "bordered exampleColumn"
             :width        170}])

         (when (get-in @!searchAddFields [:job])
           [:> rv/Column
            {:label        "Beruf"
             :dataKey      (name :beruf)
             :className    "bordered exampleColumn"
             :cellRenderer job-status-renderer
             :width        170}])

         (when (get-in @!searchAddFields [:expert])
           [:> rv/Column
            {:label        "Sachverständge(r)"
             :cellRenderer expert-renderer
             :dataKey      (name :sachverstaendiger)
             :className    "bordered exampleColumn"
             :width        170}])

         (when (get-in @!searchAddFields [:ausbildungen])
           [:> rv/Column
            {:label     "Ausbildungen"
             :dataKey   (name :ausbildungen)
             :className "bordered exampleColumn"
             :width     170}])

         (when (and (get-in @!searchAddFields [:filter-language]) "")
           [:> rv/Column
            {:label        "Sprachen"
             :dataKey      (name :language)
             :cellRenderer lang-renderer
             :className    "bordered exampleColumn"
             :width        170}])

         (when memberMode
           [:> rv/Column
            {:label        "Profil Status"
             :dataKey      (name :profileValid)
             :cellRenderer profile-valid-renderer
             :className    "bordered exampleColumn"
             :width        120}])

         (when memberMode
           [:> rv/Column
            {:label        "Mitglied Seit"
             :dataKey      (name :since)
             :className    "bordered exampleColumn"
             :width        140}])

         (when memberMode
           [:> rv/Column
            {:label        "Identität"
             :dataKey      (name :identityValid)
             :cellRenderer check-renderer
             :className    "bordered exampleColumn"
             :width        120}])

         (when memberMode
           [:> rv/Column
            {:label        "Email"
             :dataKey      (name :emailValid)
             :cellRenderer check-renderer
             :className    "bordered exampleColumn"
             :width        120}])
         (when memberMode
           [:> rv/Column
            {:label        "Handy"
             :dataKey      (name :hdyValid)
             :cellRenderer check-renderer
             :className    "bordered exampleColumn"
             :width        120}])


         (when wanadoMode
           [:> rv/Column
            {:label        "Kat"
             :dataKey      (name :helpingCat)
             :cellRenderer check-renderer
             :className    "bordered exampleColumn"
             :width        170}])
         (when wanadoMode
           [:> rv/Column
            {:label        "NoKat"
             :dataKey      (name :helpingNoCat)
             :cellRenderer check-renderer
             :className    "bordered exampleColumn"
             :width        170}])
         (when wanadoMode
           [:> rv/Column
            {:label        "Tafel"
             :dataKey      (name :helpingTafel)
             :cellRenderer check-renderer
             :className    "bordered exampleColumn"
             :width        170}])
         (when wanadoMode
           [:> rv/Column
            {:label        "LR"
             :dataKey      (name :helpingLebensretter)
             :cellRenderer check-renderer
             :className    "bordered exampleColumn"
             :width        170}])
         (when wanadoMode
           [:> rv/Column
            {:label        "Online"
             :dataKey      (name :helpingCrowdTasker)
             :cellRenderer check-renderer
             :className    "bordered exampleColumn"
             :width        170}])

         ;(when lrMode ;; TODO
         ;  [:> rv/Column
         ;   {:label     "Anzahl Einsätze"
         ;    :dataKey   (name :lrCnt)
         ;    :className "bordered exampleColumn"
         ;    :width     170}])

         (when lrMode
           [:> rv/Column
            {:label     "Datenherkunft"
             :dataKey   (name :lrSource)
             :className "bordered exampleColumn"
             :width     170}])


         (when lrMode
           [:> rv/Column
            {:label     "LR Angemeldet"
             :dataKey   (name :helpingLebensretterSince)
             :className "bordered exampleColumn"
             :width     170}])

         (when lrMode
           [:> rv/Column
            {:label     "Lebensretter bis"
             :dataKey   (name :lrTo)
             :className "bordered exampleColumn"
             :width     170}])

         (when lrMode
           [:> rv/Column
            {:label     "LR Regionen"
             :dataKey   (name :lrRegion)
             :className "bordered exampleColumn"
             :width     170}])

         (when (and lrMode (d-rights/allow-admin-for d-rights/FIRST_RESPONDER))
           [:> rv/Column
            {:label     "FR Regionen"
             :dataKey   (name :frRegion)
             :className "bordered exampleColumn"
             :width     170}])

         (when lrMode
           [:> rv/Column
            {:label     "Freigeschaltet als"
             :dataKey   (name :lrType)
             :className "bordered exampleColumn"
             :width     170}])

         (when tafelMode
           [:> rv/Column
            {:label     "Tafel seit"
             :dataKey   (name :helpingTafelSince)
             :className "bordered exampleColumn"
             :width     170}])

         (when tafelMode
           [:> rv/Column
            {:label     "Gelegentlich"
             :dataKey   (name :helpingTafelOnce)
             :cellRenderer check-renderer
             :className "bordered exampleColumn"
             :width     170}])

         (when tafelMode
           [:> rv/Column
            {:label     "Regelmäßig"
             :dataKey   (name :helpingTafelRegular)
             :cellRenderer check-renderer
             :className "bordered exampleColumn"
             :width     170}])

         (when tafelMode
           [:> rv/Column
            {:label     "Fahrer Abholung"
             :dataKey   (name :helpingTafelDriver)
             :cellRenderer check-renderer
             :className "bordered exampleColumn"
             :width     170}])

         (when tafelMode
           [:> rv/Column
            {:label     "Helfer Abholung"
             :dataKey   (name :helpingTafelHelfer)
             :cellRenderer check-renderer
             :className "bordered exampleColumn"
             :width     170}])

         (when tafelMode
           [:> rv/Column
            {:label     "Zusteller"
             :dataKey   (name :helpingTafelDeliverer)
             :cellRenderer check-renderer
             :className "bordered exampleColumn"
             :width     170}])

         ]))))





(defn table [!st rows]
  (fn [] [:> rv/AutoSizer
          {:style {:height "100%" :minHeight "400px"}
           :sort  (str "rerender !st" @!st)}
          (inside-table !st rows)]))